export enum Permission {
  RetailerCollections = 'retailer-collections',
  Admin = 'admin_panel.legacy_permission',
}
